export const SOFTLINE_API_ARCHIVE_READ = '/v1/archive/read/{{key}}';
export const SOFTLINE_API_ARCHIVE_UPLOAD = '/v1/archive/upload';
export const SOFTLINE_API_ARCHIVE_DOWNLOAD = '/v1/archive/download/{{fileKey}}';
